import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import CommonFilter from 'components/commonFilter/CommonFilter';
import CommonDialog from 'components/commonDialog/CommonDialog';
import OtpDialog from 'components/otpDialog/OtpDialog';
import SuccessDialog from 'components/successDialog/SuccessDialog';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import SearchBar from 'components/commonSearch/SearchBar';

function CommonButtonHeader(props) {
  const {
    buttonFilterdata,
    buttontitle,
    buttonFormData,
    onSelectDateRange,
    onImageChange,
    onSubmittBtn,
    showOtherComponent,
    onSearch,
    closeUploadCompliance,
  } = props;
  const [open, setOpen] = useState(false);
  const [otpDialog, setOtpDialog] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setOtpDialog(false);
    setSuccessDialog(false);
  };

  const addVendor = () => {
    if (buttontitle === 'Vehicle +') {
      setOpen(true);
    closeUploadCompliance();
    } else {
      setOpen(true);
    }
  };

  const onDialog = (data, code) => {
    onSubmittBtn(data, code);
    if (buttontitle === 'Vehicle +') {
      setOpen(true);
    } else {
      setOpen(false);
    }
    setOtpDialog(false);
  };

  const onOtpButton = () => {
    setOtpDialog(false);
    setSuccessDialog(true);
  };

  return (
    <Grid
      item
      sm={6}
      md={12}
      container
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      className="margin10"
    >
      <Grid item className="marginRight10">
        <SearchBar onSearch={onSearch} />
      </Grid>
      <Grid item className="marginInline30">
        <CommonFilter
          defaultStatus={props.defaultStatus}
          filterdata={buttonFilterdata}
          onFilterChange={props?.onFilterChange}
          onRestFilter={props?.onRestFilter}
        />
      </Grid>
      {props?.companyType !== 'adminCompany' && <Grid item>
        <Button className="btnSubvendor" onClick={() => addVendor()}>
          {buttontitle}
        </Button>
      </Grid>}

      {buttontitle === 'Vehicle +' && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={buttonFormData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'Create'}
          setOpen={false}
          type={'Vehicle'}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName={'vehicle'}
        />
      )}

      {open && buttontitle !== 'Vehicle +' && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={buttonFormData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          type={buttontitle}
          selectType={'vendorAdd'}
          defaultValues={props?.defaultValues}
        />
      )}
      {otpDialog && (
        <OtpDialog
          open={otpDialog}
          handleClose={handleClose}
          onSubmittBtn={onOtpButton}
        />
      )}
      {successDialog && (
        <SuccessDialog
          open={successDialog}
          handleClose={handleClose}
          type={'City Manager'}
        />
      )}
    </Grid>
  );
}

export default CommonButtonHeader;
